import { api } from './api';

/** The answer an add gets when agents of that name are already on file; `error.data` lists them. */
export const DUPLICATE_AGENT = 'DUPLICATE_AGENT';

/**
 * Add an agent. The server makes its Kore lead first, so nothing is saved
 * when Kore refuses. Rejects with `code === DUPLICATE_AGENT` when an agent of
 * that name exists; pass `force` to add it regardless.
 *
 * @param {Object} agent the row as the screen holds it
 * @param {{force?: boolean}} [options]
 * @returns {Promise<Object>} the new agent row
 */
export function createAgent(agent, { force = false } = {}) {
    return api.post('/agents', { ...agent, force }).then((res) => res.data);
}

/**
 * Save an edit from the agent screen. The server carries it on to the
 * agent's Kore lead, and refuses the save when Kore does not accept it.
 *
 * @param {string|number} id ARCIMEDES_ROW_ID
 * @param {Object} agent the row as the screen holds it
 * @returns {Promise<Object>} the saved agent row
 */
export function updateAgent(id, agent) {
    return api.patch(`/agents/${id}`, agent).then((res) => res.data);
}
